module.exports = __webpack_public_path__ + "img/智慧林草.ec98b0be.png";